export const siteSettings = {
  name: "Market Capital Alliance",
  link: "https://marketcapitalalliance.com",
  email: "support@marketcapitalalliance.com",
  appLink: "https://app.marketcapitalalliance.com",
};
